import { AnimatePresence, motion } from 'framer-motion';
import type { FC } from 'react';
import { useState } from 'react';
import Image from './image';

interface ImageCarouselProps {
  images: string[];
  className?: string;
}

const ImageCarousel: FC<ImageCarouselProps> = ({ images, className }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const nextImage: () => void = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevImage: () => void = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1,
    );
  };

  return (
    <div className="relative overflow-hidden">
      <AnimatePresence initial={false} mode="wait">
        <motion.div
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: '-100%' }}
          initial={{ opacity: 0, x: '100%' }}
          key={currentImageIndex}
          transition={{ duration: 0.3 }}
        >
          <Image
            alt={`Image ${currentImageIndex}`}
            className={className || 'w-[full] h-full object-cover'}
            src={images[currentImageIndex]}
          />
        </motion.div>
      </AnimatePresence>
      {images.length > 1 ? (
        <div>
          <button
            className="absolute top-1/2 left-4 p-px rounded-full
        transition-smooth hover:scale-105 transform -translate-y-1/2 details-slick-prev"
            onClick={prevImage}
            type="button"
          />
          <button
            className="absolute top-1/2 right-4 p-px rounded-full
        transition-smooth hover:scale-105 transform -translate-y-1/2 details-slick-next"
            onClick={nextImage}
            type="button"
          />
        </div>
      ) : null}
    </div>
  );
};

export default ImageCarousel;
